export const getReadableTimezone = () => {
  const date = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' });
  const parts = formatter.formatToParts(date);
  const timezoneName = parts.find((part) => part.type === 'timeZoneName').value;

  return timezoneName;
};
